.agi85e0 {
  position: relative;
  display: inline-flex;
  width: var(--pluma-space-200);
  height: var(--pluma-space-200);
  flex-shrink: 0;
}
.agi85e1 {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  transition: opacity var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-entrance-expressive);
}
[data-gradient-ring]:hover .agi85e1, [data-gradient-ring]:focus-within .agi85e1, [data-gradient-ring-active] .agi85e1 {
  opacity: 0;
}
.agi85e2 {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}
.agi85e3 {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity var(--pluma-motion-duration-moderate-01) var(--pluma-motion-easing-entrance-expressive);
}
[data-gradient-ring]:hover .agi85e3, [data-gradient-ring]:focus-within .agi85e3, [data-gradient-ring-active] .agi85e3 {
  opacity: 1;
}
@media (prefers-reduced-motion: reduce) {
  .agi85e1 {
    transition: none;
  }
  .agi85e3 {
    transition: none;
  }
}